import { PlanGate } from "@/components/plan-gate.tsx";
import { ConnectionsSection } from "@/components/private-models/connections-section.tsx";
import { PrivateModelsList } from "@/components/private-models/private-models-list.tsx";
import { m } from "@/paraglide/messages.js";
import {
	connectionsQueryOptions,
	privateModelsQueryOptions,
} from "@/services/private-models-service.ts";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

// Private models are a Team-plan feature. Gateway is a single-user pay-per-use
// product and doesn't include private models in its bundle — PlanGate below
// renders the Team upsell to Gateway customers the same way it does to Free
// and Starter, instead of redirecting them away.
export const Route = createFileRoute(
	"/_authenticated/settings/org/private-models",
)({
	component: RouteComponent,
	loader: async ({ context: { queryClient } }) => {
		queryClient.prefetchQuery(privateModelsQueryOptions());
		queryClient.prefetchQuery(connectionsQueryOptions());
	},
	head: () => ({
		meta: [{ title: pageTitle(m.private_models_title()) }],
	}),
});

function RouteComponent() {
	return (
		<PlanGate
			requiredPlan="team"
			featureName={m.plan_gate_feature_private_models()}
			variant="lightweight"
			description={m.plan_gate_desc_private_models()}
		>
			<div className="space-y-6">
				<ConnectionsSection />
				<PrivateModelsList />
			</div>
		</PlanGate>
	);
}
